import React from "react";
import { Container } from "react-bootstrap";
import profile from "../../config/profile.json";

// These badges are rendered by free third-party services (Vercel/Heroku
// deployments not run by this project) that periodically go down or hit
// their usage limits - hide the broken-image icon rather than show it
// indefinitely when that happens.
function hideOnError(e) {
  e.currentTarget.style.display = "none";
}

function TechStack() {
  const { username } = profile.socials.github;
  return (
    <Container
      fluid
      className="about-section"
      id="skills"
      style={{ paddingTop: "20px", paddingBottom: "20px" }}
    >
      <Container>
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Languages and Tools:
        </h3>
        <p
          style={{
            textAlign: "center",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "15px",
            marginBottom: "25px",
          }}
        >
          <a href="https://www.python.org" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
              alt="python"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.java.com" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg"
              alt="java"
              width="40"
              height="40"
            />
          </a>
          <a
            href="https://learn.microsoft.com/en-us/dotnet/csharp/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg"
              alt="csharp"
              width="40"
              height="40"
            />
          </a>
          <a href="https://dotnet.microsoft.com/" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg"
              alt="dotnet"
              width="40"
              height="40"
            />
          </a>
          <a href="https://go.dev" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/go/go-original.svg"
              alt="go"
              width="40"
              height="40"
            />
          </a>
          <a
            href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
              alt="javascript"
              width="40"
              height="40"
            />
          </a>
          <a
            href="https://www.typescriptlang.org/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg"
              alt="typescript"
              width="40"
              height="40"
            />
          </a>
          <a
            href="https://www.djangoproject.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://cdn.worldvectorlogo.com/logos/django.svg"
              alt="django"
              width="40"
              height="40"
            />
          </a>
          <a
            href="https://flask.palletsprojects.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://www.vectorlogo.zone/logos/pocoo_flask/pocoo_flask-icon.svg"
              alt="flask"
              width="40"
              height="40"
            />
          </a>
          <a href="https://spring.io/" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/springio/springio-icon.svg"
              alt="spring"
              width="40"
              height="40"
            />
          </a>
          <a href="https://reactjs.org/" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg"
              alt="react"
              width="40"
              height="40"
            />
          </a>
          <a href="https://nodejs.org" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg"
              alt="nodejs"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.postgresql.org" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg"
              alt="postgresql"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.mysql.com/" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg"
              alt="mysql"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.mongodb.com/" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg"
              alt="mongodb"
              width="40"
              height="40"
            />
          </a>
          <a href="https://redis.io" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original-wordmark.svg"
              alt="redis"
              width="40"
              height="40"
            />
          </a>
          <a href="https://cloud.google.com" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg"
              alt="gcp"
              width="40"
              height="40"
            />
          </a>
          <a href="https://aws.amazon.com" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"
              alt="aws"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.docker.com/" target="_blank" rel="noreferrer">
            <img
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg"
              alt="docker"
              width="40"
              height="40"
            />
          </a>
          <a href="https://kubernetes.io" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/kubernetes/kubernetes-icon.svg"
              alt="kubernetes"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.terraform.io/" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/terraformio/terraformio-icon.svg"
              alt="terraform"
              width="40"
              height="40"
            />
          </a>
          <a href="https://grafana.com" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/grafana/grafana-icon.svg"
              alt="grafana"
              width="40"
              height="40"
            />
          </a>
          <a href="https://prometheus.io/" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/prometheusio/prometheusio-icon.svg"
              alt="prometheus"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.elastic.co" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/elastic/elastic-icon.svg"
              alt="elasticsearch"
              width="40"
              height="40"
            />
          </a>
          <a href="https://kafka.apache.org/" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/apache_kafka/apache_kafka-icon.svg"
              alt="kafka"
              width="40"
              height="40"
            />
          </a>
          <a href="https://pytorch.org/" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/pytorch/pytorch-icon.svg"
              alt="pytorch"
              width="40"
              height="40"
            />
          </a>
          <a href="https://www.tensorflow.org" target="_blank" rel="noreferrer">
            <img
              src="https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg"
              alt="tensorflow"
              width="40"
              height="40"
            />
          </a>
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
          }}
        >
          {/* These are fixed-width external SVG badges; without max-width
              they overflow narrow viewports and force the page to scroll
              horizontally. */}
          <img
            src={`https://github-readme-stats.vercel.app/api/top-langs?username=${username}&show_icons=true&locale=en&layout=compact&hide=html,css,scss,php,mako`}
            alt={username}
            style={{ maxWidth: "100%", height: "auto" }}
            onError={hideOnError}
          />

          <img
            src={`https://github-readme-streak-stats.herokuapp.com/?user=${username}&`}
            alt={username}
            style={{ maxWidth: "100%", height: "auto" }}
            onError={hideOnError}
          />

          <img
            src={`https://komarev.com/ghpvc/?username=${username}&label=Profile%20views&color=0e75b6&style=flat`}
            alt={username}
            style={{ maxWidth: "100%", height: "auto" }}
            onError={hideOnError}
          />
        </div>
      </Container>
    </Container>
  );
}

export default TechStack;
